import { DateTime } from 'luxon';

import { accountsSelectors } from 'app-components/flux/accounts';
import store from 'app-components/utils/redux-store';

export const alertsPayload = () => {
  const cashAccount = accountsSelectors.getCashAccounts(store.getState())?.first();
  return [
    {
      alertType: 'PLANNED_SPENDING_ITEM_TARGET',
      alertSubtype: 'APPROACHING_TARGET',
      data: {
        name: 'Bars',
        calculatedSpentAmount: -99.78,
        targetAmount: 100.12,
        deepLinkEntityId: '123456',
      },
    },
    {
      alertType: 'PLANNED_SPENDING_ITEM_TARGET',
      alertSubtype: 'OVER_TARGET',
      data: {
        name: 'Bars',
        calculatedSpentAmount: -101.34,
        targetAmount: 100.12,
        deepLinkEntityId: '123456',
      },
    },
    {
      alertType: 'BADGE_EARNED',
      data: {
        achievementName: 'Asset Accumulator',
        nameLevel: 'Asset Accumulator: Level 3',
        milestoneDescription: 'Reached $500K Total Net Worth',
        imageUrl: 'https://s3-us-west-2.amazonaws.com/quickencs-images/gamification/8000010003.svg',
        pngImageUrl: 'https://s3-us-west-2.amazonaws.com/quickencs-images/gamification/8000010003.png',
        nextMilestone: 'Reach $1M in Total Net Worth',
        mainContentLine2: "You're on your way to accumulating more & more wealth - keep it up!",
        mainContentLine1: 'Your net worth is on the rise!',
      },
    },
    {
      alertType: 'BILLS_TO_INCOME_PERCENTAGE',
      data: {
        billsToIncomePercentage: 10,
        expectedIncome: 3000,
        expectedBills: 1000,
      },
    },
    {
      alertType: 'EXTRA_PAYCHECK',
      data: {
        numPaychecks: 2,
      },
    },
    {
      alertType: 'GOALS_CONTRIBUTIONS',
      alertSubtype: 'NO_CONTRIBUTIONS',
      data: {
        numberOfGoals: 2,
        numberOfGoalsWithNoContributions: 2,
      },
    },
    {
      alertType: 'GOALS_CONTRIBUTIONS',
      alertSubtype: 'GOAL_CONTRIBUTION_NOT_MET',
      data: {
        numberOfGoals: 2,
        numberOfDaysLeft: 3,
      },
    },
    {
      alertType: 'MONTHLY_SPENDING_COMPARISON',
      data: {
        currentSpending: 1200,
        previousSpending: 1100,
      },
    },
    {
      alertType: 'MONTHLY_SUMMARY',
    },
    {
      alertType: 'RECURRING_TXNS_WEEKLY_SUMMARY',
      data: {
        numberOfBills: 4,
      },
    },
    {
      alertType: 'UNCATEGORIZED_TXNS',
      data: {
        number: 5,
        coaType: 'UNCATEGORIZED',
        coaId: '0',
      },
    },
    {
      alertType: 'FREE_TO_SPEND_LOW',
    },
    {
      alertType: 'WATCHLIST_TARGET',
      alertSubtype: 'APPROACHING_TARGET',
      data: {
        name: 'Gas',
        spentSoFar: -99,
        thisMonth: -99,
        targetAmount: 100,
        deepLinkEntityId: '123456',
      },
    },
    {
      alertType: 'WATCHLIST_TARGET',
      alertSubtype: 'OVER_TARGET',
      data: {
        name: 'Gas',
        spentSoFar: -101,
        thisMonth: -101,
        targetAmount: 100,
        deepLinkEntityId: '123456',
      },
    },
    {
      alertType: 'BANK_FEE',
      data: {
        amount: 23,
        deepLinkEntityId: '123456',
        accountName: cashAccount?.name || 'Test Account',
        currency: '$',
        date: DateTime.local().toISODate(),
        payee: 'Test Payee',
      },
    },
    {
      alertType: 'LARGE_DEPOSIT',
      data: {
        amount: 1200,
        deepLinkEntityId: '123456',
        payee: 'Test Payee',
        accountName: cashAccount?.name || 'Test Account',
        currency: '$',
        date: DateTime.local().toISODate(),
      },
    },
    {
      alertType: 'LARGE_PURCHASE',
      data: {
        amount: 1400,
        deepLinkEntityId: '123456',
        payee: 'Test Payee',
        accountName: cashAccount?.name || 'Test Account',
        currency: '$',
        date: DateTime.local().toISODate(),
      },
    },
    {
      alertType: 'RECURRING_TXN_EXPENSE',
      data: {
        amount: 60,
        deepLinkEntityId: '123456',
        payee: 'Test Payee',
        accountName: cashAccount?.name || 'Test Account',
        amountVariance: 55,
        currency: '$',
        date: DateTime.local().toISODate(),
        dateVariance: DateTime.local().toISODate(),
        expectedAmount: 56,
        expectedDate: DateTime.local().toISODate(),
      },
    },
    {
      alertType: 'RECURRING_TXN_INCOME',
      data: {
        amount: 60,
        deepLinkEntityId: '123456',
        payee: 'Test Payee',
        accountName: cashAccount?.name || 'Test Account',
        amountVariance: 55,
        currency: '$',
        date: DateTime.local().toISODate(),
        dateVariance: DateTime.local().toISODate(),
        expectedAmount: 56,
        expectedDate: DateTime.local().toISODate(),
      },
    },
    {
      alertType: 'BUDGET_ITEM_LOW',
    },
    {
      alertType: 'BUDGET_ITEM_OVER',
    },
    {
      alertType: 'REFUND_TRACKER',
      alertSubtype: 'REFUND_OVERDUE',
      data: {
        deepLinkEntityId: '123456',
        amount: 60,
        payee: 'Test Payee',
        currency: '$',
      },
    },
    {
      alertType: 'REFUND_TRACKER',
      alertSubtype: 'REFUND_RECEIVED',
      data: {
        deepLinkEntityId: '123456',
        amount: 60,
        payee: 'Test Payee',
        currency: '$',
      },
    },
    {
      alertType: 'LOW_BALANCE',
      data: {
        deepLinkEntityId: cashAccount?.id || '123456',
        accountName: cashAccount?.name || 'Test Account',
        amount: 1,
        threshold: 111,
      },
    },
    {
      alertType: 'HIGH_BALANCE',
      data: {
        deepLinkEntityId: cashAccount?.id || '123456',
        accountName: cashAccount?.name || 'Test Account',
        amount: 111111,
        threshold: 1111,
      },
    },
    {
      alertType: 'PROJECTED_LOW_BALANCE',
      data: {
        deepLinkEntityId: cashAccount?.id || '123456',
        amount: 1,
        threshold: 111,
        accountName: cashAccount?.name || 'Test Account',
        date: DateTime.local().toISODate(),
      },
    },
  ];
};
export default alertsPayload;
